import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'

import { ReactComponent as CloseSVG } from 'shared/img/close.svg'
import logo from 'shared/img/logo.webp'
import successImage from 'shared/img/success.webp'

import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from 'components/HOC/withModalQuery/ModalContext'

import Button from 'components/UIKit/Button/Button'

import './SuccessChangedPassword.scss'

const b = block('success-change-password')

export const SuccessChangedPassword: React.FC = () => {
  const { closeModal } = useModalContext()
  const { betHistory, auth } = useSelector(selectLocaleDict, shallowEqual)

  const onCloseModal = () => {
    closeModal(MODAL_ROUTE_URLS.SUCCESS_CHANGED_PASSWORD())()
  }
  
  return (
    <section className={b()}>
      <div className={b('header')}>
        <span>{auth.passwordChangedSuccessfully}</span>
        <CloseSVG className={b('close')} onClick={onCloseModal} />
      </div>
      <div className={b('content')}>
        <img src={successImage} alt='' className={b('image')} />
        <div className={b('button-container')}>
          <Button
            text={betHistory.ok}
            variant="main"
            callback={onCloseModal}
          />
        </div>
      </div>
      <div className={b('separator')} />
      <img src={logo} alt='' className={b('logo')} />
    </section>
  )
}
